import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DataCatalogueService } from "../services/data-catalogue.service";

@Component({
  selector: "business-rule-view",
  templateUrl: "./business-rule-view.component.html",
  styleUrls: ["./business-rule-view.component.scss"],
})
export class BusinessRuleViewComponent implements OnInit {
  form: FormGroup;
  id: string | null = null;
  matchingRule: any;
  mode: "create" | "edit";
  initialFormValues: any;
  catalogueId: string = "2037172d-1390-4033-9017-e5424166927e";
  rulesets: any;
  ruleLangs = ["Schematron"];
  statusOptions = ["Active", "Proposed", "Work in progress", "Rejected"];

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private catalogueService: DataCatalogueService
  ) {}

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get("ruleId");

    this.catalogueService.getRulesets(this.catalogueId).subscribe({
      next: (res: any[]) => {
        this.rulesets = res[0];
        console.log("rulesets:", res);
      },
      error: (err) => {
        console.error("Greška pri dohvaćanju rulset:", err);
      },
    });

    if (this.id === "create") {
      this.mode = "create";
    } else {
      this.mode = "edit";
    }

    this.form = this.fb.group({
      identifier: [
        { value: null, disabled: this.mode === "edit" },
        [
          this.mode === "create" ? Validators.required : [],
          this.mode === "create" ? Validators.minLength(3) : [],
          this.mode === "create" ? Validators.maxLength(255) : [],
        ],
      ],
      ruleName: [
        null,
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(255),
        ],
      ],
      description: [null],
      diagnostic: [null, Validators.required],
      suggestion: [null],
      ruleLang: [{ value: "Schematron", disabled: true }, Validators.required],
      context: [null, Validators.required],
      ruleText: [null, Validators.required],
      ruleType: ["assert", Validators.required],
      status: ["Work in progress", Validators.required],
      aixmClass: [null],
      aixmAttribute: [null],
    });

    if (this.id === "create") {
      this.mode = "create";
      this.form.patchValue({
        ruleLang: "Schematron",
        status: "Work in progress",
        ruleType: "assert",
      });
      this.initialFormValues = this.form.getRawValue();
      return;
    }

    if (this.id) {
      this.mode = "edit";
      this.catalogueService.getRule(this.catalogueId, this.id).subscribe({
        next: (res) => {
          console.log("Loaded test :", res);

          this.matchingRule = res;
          this.form.patchValue({
            identifier: res.id,
            ruleName: res.name,
            description: res.description,
            diagnostic: res.diagnostic,
            suggestion: res.suggestion,
            ruleLang: "Schematron",
            context: res.context,
            ruleText: res.rule,
            ruleType: res.ruleType || "assert",
            status: res.statusGroup?.status || "Work in progress",
            aixmClass: res.aixmClass,
            aixmAttribute: res.aixmAttribute,
          });
          this.initialFormValues = this.form.getRawValue();
        },
        error: (err) => {
          console.error("Error loading rule metadata:", err);
        },
      });
    }
  }

  resetFields(): void {
    if (this.form && this.initialFormValues) {
      this.form.reset(this.initialFormValues);
    }
  }
  saveRule(): void {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    const payload: any = {
      id: this.form.get("identifier")?.value,
      name: this.form.get("ruleName")?.value,
      description: this.form.get("description")?.value,
      diagnostic: this.form.get("diagnostic")?.value,
      suggestion: this.form.get("suggestion")?.value,
      aixmClass: this.form.get("aixmClass")?.value,
      aixmAttribute: this.form.get("aixmAttribute")?.value,
      ruleLanguage: this.form.get("ruleLang")?.value,
      context: this.form.get("context")?.value,
      rule: this.form.get("ruleText")?.value,
      ruleType: this.form.get("ruleType")?.value || "assert",

      statusGroup: {
        status: this.form.get("status")?.value,
      },

      rulesetsGroup: [
        {
          // uuid: "bdb68c43-f248-4c2f-8a27-d8c246c7b229",
          // versions: [
          //   {
          //     version: this.matchingRule?.version?.version || 0,
          //     timestamp: new Date().toISOString(),
          //     author: "UI",
          //     name: this.form.get("ruleName")?.value,
          //   },
          // ],
          uuid: this.rulesets.uuid,
          versions: [
            {
              version: this.rulesets.versions[0].version,
              timestamp: this.rulesets.versions[0].timestamp,
              author: this.rulesets.versions[0].author,
              name: this.rulesets.versions[0].name,
            },
          ],
        },
      ],

      version: {
        version: this.rulesets.versions[0].version,
        timestamp: this.rulesets.versions[0].timestamp,
        author: this.rulesets.versions[0].author,
        authorUUID: this.rulesets.versions[0].authorUUID,
      },
    };

    if (this.mode === "create") {
      this.catalogueService.createRule(this.catalogueId, payload).subscribe({
        next: (res) => {
          console.log("Rule created:", res);

          this.form.reset({
            identifier: null,
            ruleName: null,
            description: null,
            diagnostic: null,
            suggestion: null,
            ruleLang: "Schematron",
            context: null,
            ruleText: null,
            ruleType: "assert",
            status: "Work in progress",
            aixmClass: null,
            aixmAttribute: null,
          });

          const identifier = this.form.get("identifier");
          identifier?.enable();
          identifier?.setValidators([
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(255),
          ]);
          identifier?.updateValueAndValidity();

          this.initialFormValues = this.form.getRawValue();
        },
        error: (err) => {
          console.error("Error creating rule:", err);
        },
      });
    } else if (this.mode === "edit" && this.matchingRule?.id) {
      console.log("update", this.catalogueId, this.matchingRule.id, payload);
      this.catalogueService
        .updateRule(this.catalogueId, this.matchingRule.id, payload)
        .subscribe({
          next: (res) => {
            console.log("Rule updated:", res);
            this.initialFormValues = this.form.getRawValue();
          },
          error: (err) => {
            console.error("Error updating rule:", err);
          },
        });
    }
  }
}
